import * as React from "react";
import classnames from "../../../../../../_virtual/index.js";
import { useLink } from "@grandvisionhq/frk-routing";
import { Icon } from "@grandvisionhq/icons";
import { pushWishlistEvent } from "../../../../../../data-layer/data-layer/wishlist.js";
import { useGetMyWishlistId } from "../../../../../../hooks/hooks/use-get-my-wishlist-id.js";
import { useGetShoppingListCount } from "../../../../../../hooks/hooks/use-get-shopping-list-count.js";
import { useGetWishlistAriaLabel } from "../../../../hooks/modules/menu-item/hooks/use-get-wishlist-aria-label.js";
const UserWishlistMenuItem = ({
  label,
  className,
  tabIndex,
  tealiumAttributes
}) => {
  const { href } = useLink({ route: "me.wishlist" }) || {};
  const { id } = useGetMyWishlistId();
  const { itemsCount } = useGetShoppingListCount(id);
  const count = itemsCount || 0;
  const ariaLabel = useGetWishlistAriaLabel(count);
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      className: classnames("wishlist-menu-item", className),
      href,
      title: label,
      tabIndex,
      "aria-label": tabIndex === -1 ? "" : ariaLabel,
      onClick: () => pushWishlistEvent({
        interactionType: "wishlist_top_menu_click",
        siteFeature: "wishlist_flow"
      }),
      ...tealiumAttributes
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "favourite-empty" }),
    count > 0 && /* @__PURE__ */ React.createElement("span", { className: "wishlist-menu-item__counter" }, count)
  );
};
export {
  UserWishlistMenuItem as default
};
//# sourceMappingURL=UserWishlistMenuItem.js.map
